// docs: https://github.com/altostra/type-validations#readme
import { recordOf, objectOf, tupleOf, arrayOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isAppsAppGroupIdChartsFormulaDataResult = recordOf({
  key: string,
  value: objectOf({
    data: recordOf({ key: string, value: recordOf({ key: number, value: number }) }),
    denominators: arrayOf(tupleOf(string, objectOf({ m: number, ft: number }))),
    numerator: arrayOf(tupleOf(string, objectOf({ m: number, ft: number }))),
    per_segment_data: recordOf({
      key: string,
      value: recordOf({ key: string, value: recordOf({ key: number, value: number }) }),
    }),
    timestamps: arrayOf(number),
  }),
});
